import { Link } from "react-router-dom";

export default function Disclaimer() {
  return (
    <div data-testid="disclaimer-page">
      {/* Hero Section */}
      <section className="py-16 bg-[#0F172A]">
        <div className="container-custom">
          <h1 className="heading-h1 text-white">DISCLAIMER</h1>
          <p className="text-slate-400 mt-4">Last updated: December 2024</p>
        </div>
      </section>

      {/* Content */}
      <section className="section-padding bg-light">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto policy-content">
            <p className="text-body mb-8">
              The information provided by Cart Genix ("we," "us," or "our") on our website 
              is for general informational purposes only. All information on the site is 
              provided in good faith, however, we make no representation or warranty of any kind, 
              express or implied, regarding the accuracy, adequacy, validity, reliability, 
              availability, or completeness of any information on the site.
            </p>

            <h2>Professional Advice Disclaimer</h2>
            <p>
              The information contained on this website is not intended to be a substitute for 
              professional roofing advice. Always seek the advice of a qualified roofing professional 
              with any questions you may have regarding your roof's condition or repair needs.
            </p>

            <h2>Estimates and Pricing</h2>
            <p>
              Any estimates, quotes, or pricing information provided on this website or through 
              our services are for general reference only and are subject to change. Actual costs 
              may vary based on:
            </p>
            <ul>
              <li>The specific condition of your roof</li>
              <li>Material costs at the time of service</li>
              <li>Accessibility and complexity of the project</li>
              <li>Local building codes and permit requirements</li>
              <li>Additional work discovered during the project</li>
            </ul>

            <h2>External Links Disclaimer</h2>
            <p>
              This website may contain links to external websites that are not provided or 
              maintained by Cart Genix. We do not guarantee the accuracy, relevance, timeliness, 
              or completeness of any information on these external websites.
            </p>

            <h2>Testimonials Disclaimer</h2>
            <p>
              The testimonials displayed on this website are the personal experiences and opinions 
              of our customers. Individual results may vary, and testimonials are not intended to 
              be representative of all customer experiences.
            </p>

            <h2>Images and Representations</h2>
            <p>
              Images and descriptions of roofing work shown on this website are for illustrative 
              purposes only. Actual results may vary based on your specific property, materials 
              selected, and other factors.
            </p>

            <h2>Service Area</h2>
            <p>
              While we strive to serve all areas mentioned on this website, service availability 
              may vary based on location, demand, and other factors. Please contact us to confirm 
              service availability in your area.
            </p>

            <h2>Weather and Scheduling</h2>
            <p>
              Roofing work is weather-dependent. While we make every effort to complete projects 
              on schedule, delays may occur due to inclement weather, material availability, or 
              other circumstances beyond our control.
            </p>

            <h2>Insurance and Warranty Claims</h2>
            <p>
              We can assist with insurance claims and warranty matters, but we cannot guarantee 
              specific outcomes. Final decisions regarding insurance claims are made by your 
              insurance provider.
            </p>

            <h2>No Guarantees</h2>
            <p>
              While we stand behind our work with warranties and guarantees as specified in our 
              service agreements, we cannot guarantee specific outcomes or that our services will 
              meet all of your expectations. Roofing is subject to many variables including weather, 
              the age of your home, and underlying structural conditions.
            </p>

            <h2>Errors and Omissions</h2>
            <p>
              We make reasonable efforts to ensure that all information on this website is accurate 
              and current. However, errors and omissions may occur. If you notice any inaccuracies, 
              please contact us so we can correct them.
            </p>

            <h2>Limitation of Liability</h2>
            <p>
              Under no circumstance shall Cart Genix be liable for any direct, indirect, special, 
              incidental, or consequential damages arising from your use of our website or reliance 
              on any information provided herein.
            </p>

            <h2>Contact Us</h2>
            <p>If you have any questions about this Disclaimer, please contact us:</p>
            <ul>
              <li><strong>Email:</strong> support@cartgenix.store</li>
              <li><strong>Phone:</strong> +1-888-445-1244</li>
              <li><strong>Address:</strong> 998 Sunset Boulevard, Los Angeles, CA 80021</li>
            </ul>

            <div className="mt-12 pt-8 border-t border-slate-200">
              <Link to="/" className="text-[#F97316] font-semibold hover:underline">
                ← Back to Home
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
